export default __webpack_public_path__ + "static/blob2-c216d58b98ef9ad2cc7df568d6b218b0.svg";